import { UIController } from "./ui.controller";

const isPage = (slug) => document.body.classList.contains(slug);

export const NavController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initMobileMenuToggle();
        this.initMobileSubMenus();

        if (!isPage("page-template-full-embed-template")) {
          this.initStickyHeader();
        } else {
          this.initFixedHeader();
        }

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  menuIsMobileMode() {
    return window.innerWidth < 1024;
  },

  initStickyHeader() {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 0) {
        document.documentElement.classList.add("scrolled");
      } else {
        document.documentElement.classList.remove("scrolled");
      }
    };
    const handler = handleScroll;
    window.addEventListener("scroll", handler);
    handler();
  },

  initFixedHeader() {
    document.documentElement.classList.add("scrolled");
  },

  toggleMobileMenu: () => {
    const html = document.documentElement;
    const menuIsOpen = html.classList.contains("menu-open");
    if (menuIsOpen) {
      html.classList.remove("menu-open");
    } else {
      html.classList.add("menu-open");
      UIController.recordNavBarHeight();
    }
  },

  toggleAboutMenu: () => {
    const html = document.documentElement;
    const menuIsOpen = html.classList.contains("about-menu-open");
    if (menuIsOpen) {
      html.classList.remove("about-menu-open");
    } else {
      html.classList.add("about-menu-open");
      UIController.recordNavBarHeight();
    }
  },

  initAboutMenuToggle() {
    const toggle = document.querySelector(".about-dropdown");
    if (!toggle) return;
    toggle.addEventListener("click", this.toggleAboutMenu);
  },

  initMobileMenuToggle() {
    const toggle = document.querySelector(".nav-hamburger");
    if (!toggle) return;
    toggle.addEventListener("click", this.toggleMobileMenu);
  },

  initMobileSubMenus() {
    this.initMobileMenuTriggers();
    this.initMobileMenuParentTriggers();
  },

  initMobileMenuTriggers() {
    const els = document.querySelectorAll(".menu-item-has-children > a");

    const toggleMobileMenu = (event) => {
      const { target } = event;
      const { parentNode } = target;

      if (parentNode.classList.contains("open")) {
        parentNode.classList.remove("open");
      } else {
        parentNode.classList.add("open");
      }
    };

    Array.from(els).forEach((el) => {
      el.addEventListener("click", toggleMobileMenu);
    });

    Array.from(els).forEach((el) => {
      el.classList.remove("open");
    });
  },

  initMobileMenuParentTriggers() {
    const els = document.querySelectorAll(".menu-item-has-children > a");
  },
};
